import { useCallback, useState } from "react";

export type RequestListView = "card" | "table";

/** 一覧の表示形式の保存先（ユーザー単位の好み。API には保存しない）。 */
export const LIST_VIEW_STORAGE_KEY = "reassist.requestListView";

const readStored = (): RequestListView => {
  try {
    return window.localStorage.getItem(LIST_VIEW_STORAGE_KEY) === "table"
      ? "table"
      : "card";
  } catch {
    // localStorage が使えない環境ではカードにする
    return "card";
  }
};

/**
 * 依頼一覧の表示形式（カード／テーブル）。既定はカード。
 * 選択は localStorage に保存する。読み書きに失敗しても画面は動く。
 */
export const useRequestListView = (): [
  RequestListView,
  (view: RequestListView) => void
] => {
  const [view, setView] = useState<RequestListView>(readStored);
  const update = useCallback((next: RequestListView) => {
    setView(next);
    try {
      window.localStorage.setItem(LIST_VIEW_STORAGE_KEY, next);
    } catch {
      // 保存できなくても、この画面の間は選択を保つ
    }
  }, []);
  return [view, update];
};
